import {FC} from 'react';
import {HistoryInvoiceNumberProps} from '../../types/balance-history.types';
import {InvoiceLink, LinkText} from './styles';

export const HistoryInvoiceNumber: FC<HistoryInvoiceNumberProps> = ({href, invoiceNumber}) => {
  if (!href) return <LinkText>{invoiceNumber || '-'}</LinkText>;

  return (
    <InvoiceLink href={href} target="_blank" rel="noreferrer">
      <LinkText>{invoiceNumber || '-'}</LinkText>
    </InvoiceLink>
  );
};
